import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { GadReviewInstructionStatic } from "./GadReviewInstructionStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const GadReviewInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const GadReviewInstructionStore: GadReviewInstructionStatic = new GadReviewInstructionStatic();
